import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { lazy, Suspense, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import HeadComponent from "./components/HeadComponent";
import { useAuthSync } from "./hooks/useAuthSync";
// not using reddit pixel for now
// import { initRedditPixel } from "./utils/redditPixel";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { REGISTRATION_INELIGIBLE_PATH } from "./utils/visitorQualification";
const HomePageV4 = lazy(() => import("./pages/Home/home.v4"));
const SurveyPage = lazy(() => import("./pages/SurveyForm/survey"));
const VerifyOTP = lazy(() => import("./pages/VerifyOTP/verifyOTP"));
const SuccessPage = lazy(() => import("./pages/Successpage/successPage"));
const SuccessQRPage = lazy(() => import("./pages/SuccessQR/SuccessQRPage"));
const DetailsForm = lazy(() => import("./pages/PersonalDetailsForm/DetailsForm"));
const RegistrationFlowLayout = lazy(() => import("./pages/PersonalDetailsForm/v2/RegistrationFlowLayout"));
const UpgradeSurvey = lazy(() => import("./pages/UpgradeSurvey/UpgradeSurvey"));
const ProfileDetail = lazy(() => import("./pages/ProfileDetail/ProfileDetail"));
const ErrorTest = lazy(() => import("./components/ErrorTest"));
const LandingPage = lazy(() => import("./pages/Landing/LandingPage"));
const Login = lazy(() => import("./pages/Login/Login"));
const ExhibitorCheckIn = lazy(() => import("./pages/ExhibitorCheckIn/ExhibitorCheckIn"));
const ExhibitorCompany = lazy(() => import("./pages/ExhibitorCheckIn/ExhibitorCompany/ExhibitorCompany"));
const PaymentScreen = lazy(() => import("./pages/ExhibitorCheckIn/PaymentScreen/PaymentScreen"));
const PaymentNotMadeScreen = lazy(() => import("./pages/ExhibitorCheckIn/PaymentNotMadeScreen/PaymentNotMadeScreen"));
const BadgeNotPrintedScreen = lazy(() => import("./pages/ExhibitorCheckIn/BadgeNotPrintedScreen/BadgeNotPrintedScreen"));
const CoExhibitorCompany = lazy(() => import("./pages/ExhibitorCheckIn/CoExhibitorCompany/CoExhibitorCompany"));
const HandoverDetails = lazy(() => import("./pages/ExhibitorCheckIn/HandoverDetails/HandoverDetails"));
const NotFound = lazy(() => import("./pages/NotFound/NotFound"));
const CreativesPage = lazy(() => import("./pages/Creatives/CreativesPage"));
const CreativeDetailPage = lazy(() => import("./pages/Creatives/CreativeDetailPage"));
const FloorPlanPage = lazy(() => import("./pages/FloorPlan/FloorPlanPage"));
const FailPayment = lazy(() => import("./pages/PaymentPages/PaymentFail/PaymentFail"));
const PaymentProcessing = lazy(() => import("./pages/PaymentPages/ProcessScreen/PaymentProcessing"));
const ReferralRedirect = lazy(() => import("./pages/ReferralRedirect"));
const RegistrationIneligiblePage = lazy(() => import("./pages/RegistrationIneligible/RegistrationIneligiblePage"));

function App() {
  useAuthSync();
  const location = useLocation();

  // not using reddit pixel for now
  // useEffect(() => {
  //   initRedditPixel();
  // }, []);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname, location.key]);

  return (
    <>
      <HeadComponent title="" description="" />
      <ToastContainer
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        theme="light"
      />
      <Suspense fallback={null}>
      <Routes>
        {/* Public Routes */}
        {/* <Route element={<PublicRoute />}> */}
        <Route path="/" element={<ReferralRedirect><LandingPage /></ReferralRedirect>} />
        <Route path="/home" element={<LandingPage />} />
        <Route path="/verifyOTP" element={<VerifyOTP />} />
        <Route path="/e/:eventCode" element={<GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}><HomePageV4 /></GoogleOAuthProvider>} />
        <Route path="/error-test" element={<ErrorTest />} />
        <Route path="/profile-detail" element={<ProfileDetail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/error-test" element={<ErrorTest />} />
        {/* </Route> */}

        {/* Protected Routes */}
        {/* <Route element={<ProtectedRoute />}> */}
        <Route element={<RegistrationFlowLayout />}>
          <Route path="/details-page" element={<DetailsForm />} />
          <Route path="/survey" element={<SurveyPage />} />
        </Route>
        <Route path="/success-page" element={<SuccessPage />} />
        <Route path="/payment-failed" element={<FailPayment />} />
        <Route path={REGISTRATION_INELIGIBLE_PATH} element={<RegistrationIneligiblePage />} />
        <Route path="/payment-processing" element={<PaymentProcessing />} />
        <Route path="/success-qr-page" element={<SuccessQRPage />} />
        <Route path="/upgrade-survey" element={<UpgradeSurvey />} />
        {/* <Route path="/profile-detail" element={<ProfileDetail />} /> */}
        {/* </Route>        */}

        {/* If no route matches */}
        {/* <Route path="*" element={<Navigate to={isAuthenticated ? "/details-page" : "/"} replace />} />          */}
        <Route path="*" element={<NotFound />} />
        <Route path="/company-category/:eventCode" element={<ExhibitorCheckIn />} />
        <Route path="/company-list" element={<ExhibitorCompany />} />
        <Route path="/co-ex-company-list" element={<CoExhibitorCompany />} />
        <Route path="/more-badge" element={<PaymentScreen />} />
        <Route path="/payment-verification-pending" element={<PaymentNotMadeScreen />} />
        <Route path="/badge-not-printed" element={<BadgeNotPrintedScreen />} />
        <Route path="/handover-details" element={<HandoverDetails />} />
        <Route path="/I-am-attending" element={<Navigate to="/I-am-attending/28" replace />} />
        <Route path="/I-am-attending/:eventCode" element={<CreativesPage />} />
        <Route path="/I-am-attending/:eventCode/:templateId" element={<CreativeDetailPage />} />
        <Route path="/floorplan" element={<Navigate to="/floorplan/27" replace />} />
        <Route path="/floorplan/:eventCode" element={<FloorPlanPage />} />
      </Routes>
      </Suspense>
    </>
  );
}

export default App;
